import { useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import axios from "axios";
import Typewriter from "typewriter-effect";
import ideaImage from "../assest/idea.png"; // Replace with your own image
import { BsLightbulbFill } from "react-icons/bs";
import { Lightbulb, ArrowRight, ArrowLeft, Upload, CheckCircle, Sparkles, Users, Target, Rocket } from "lucide-react"

export default function BusinessIdeationHub() {
  const [step, setStep] = useState(0);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    district: "",
    linkedin: "",
    employmentStatus: "",
    cv: null,
  });
  const [submitted, setSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 500], [0, 100]);

  const sections = [
    {
      title: "Section 1: Personal Information",
      fields: [
        {
          label: "Full Name",
          type: "text",
          name: "fullName",
          required: true,
        },
        {
          label: "Email Address",
          type: "email",
          name: "email",
          required: true,
        },
        {
          label: "Phone Number",
          type: "tel",
          name: "phoneNumber",
          required: true,
          validation: "10-digit",
        },
        {
          label: "District",
          type: "select",
          name: "district",
          required: true,
          options: [
            "Ariyalur", "Chengalpattu", "Chennai", "Coimbatore", "Cuddalore",
            "Dharmapuri", "Dindigul", "Erode", "Kallakurichi", "Kanchipuram",
            "Kanniyakumari", "Karur", "Krishnagiri", "Madurai", "Nagapattinam",
            "Namakkal", "Nilgiris", "Perambalur", "Pudukkottai", "Ramanathapuram",
            "Ranipet", "Salem", "Sivagangai", "Tenkasi", "Thanjavur", "Theni",
            "Thoothukudi", "Tiruchirappalli", "Tirunelveli", "Tirupathur",
            "Tiruppur", "Tiruvallur", "Tiruvannamalai", "Tiruvarur", "Vellore",
            "Viluppuram", "Virudhunagar"
          ],
        },
      ],
    },
    {
      title: "Section 2: Professional Information",
      fields: [
        {
          label: "LinkedIn Profile",
          type: "url",
          name: "linkedin",
          required: true,
          placeholder: "https://www.linkedin.com/in/yourname",
        },
        {
          label: "Employment Status",
          type: "radio",
          name: "employmentStatus",
          required: true,
          options: ["Employed", "Unemployed", "Studying"],
        },
        {
          label: "Upload CV",
          type: "file",
          name: "cv",
          required: true,
          accept: ".pdf",
        },
      ],
    },
  ];

  const validateField = (name, value) => {
    switch (name) {
      case "fullName":
        if (!/^[A-Za-z\s]+$/.test(value)) {
          return "Full Name should contain only letters and spaces.";
        }
        break;
      case "email":
        if (!/^[^\s@]+@gmail\.com$/.test(value)) {
          return "Email must be a valid Gmail address.";
        }
        break;
      case "phoneNumber":
        if (!/^\d{10}$/.test(value)) {
          return "Phone Number must be exactly 10 digits.";
        }
        break;
      // case "linkedin":
      //   if (value && !/^https?:\/\/.+\..+/.test(value)) {
      //     return "LinkedIn URL must be a valid URL.";
      //   }
      // break;
      default:
        break;
    }
    return "";
  };




  const handleChange = (e) => {
    const { name, type, value, files } = e.target;

    if (type === "tel") {
      // Allow only digits and limit to 10
      const cleanedValue = value.replace(/\D/g, "").slice(0, 10);
      setFormData((prev) => ({ ...prev, [name]: cleanedValue }));
    } else if (type === "file") {
      const file = files[0];
      if (file && file.type !== "application/pdf") {
        setErrorMessage("⚠️ Only PDF files are allowed for CV upload.");
        return;
      } else {
        setErrorMessage("");
        setFormData((prev) => ({ ...prev, [name]: file }));
      }
    }
    // else if (name === "linkedin") {
    //   const linkedinPattern = /^https:\/\/(www\.)?linkedin\.com\/in\/[A-Za-z0-9_-]+\/?$/;
    //   if (!linkedinPattern.test(value)) {
    //     setErrorMessage("⚠️ Please enter a valid LinkedIn profile URL.");
    //   } else {
    //     setErrorMessage("");
    //     setFormData((prev) => ({ ...prev, [name]: value }));
    //   }
    // } 
    else if (type === "text" && name === "fullName") {
      // Allow only letters and spaces
      const cleanedValue = value.replace(/[^A-Za-z\s]/g, "");
      setFormData((prev) => ({ ...prev, [name]: cleanedValue }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: type === "file" ? files[0] : value,
      }));
    }
  };


  const handleNext = () => {
    const currentFields = sections[step].fields;
    for (let field of currentFields) {
      const isOptional = field.required === false;
      const value = formData[field.name];
      if (!value && !isOptional) {
        setErrorMessage(`⚠️ Please fill out: ${field.label}`);
        return;
      }
      const validationError = validateField(field.name, value);
      if (validationError) {
        setErrorMessage(`⚠️ ${validationError}`);
        return;
      }
    }
    setErrorMessage("");
    setStep((prev) => prev + 1);
  };
  const handleMultiSelect = (e) => {
    const values = Array.from(e.target.selectedOptions, (option) => option.value);
    setFormData((prev) => ({ ...prev, [e.target.name]: values }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Validate the last section before submitting
    const currentFields = sections[step].fields;
    for (let field of currentFields) {
      const isOptional = field.required === false;
      const value = formData[field.name];
      if (!value && !isOptional) {
        setErrorMessage(`⚠️ Please fill out: ${field.label}`);
        setLoading(false);
        return;
      }
    }

    const formDataToSend = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((val) => formDataToSend.append(key, val));
      } else {
        formDataToSend.append(key, value);
      }
    });

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/businessideationhub`,
        formDataToSend,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      console.log(response.data);
      setSubmitted(true);
    } catch (error) {
      console.error("Submission failed", error);
      setErrorMessage("Submission failed! Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const progressPercentage = ((step + 1) / sections.length) * 100

  return (
    <div>
      <div className="container py-8">
        <div className="grid lg:grid-cols-2 gap-8 items-center">
          {/* Left Content */}
          <div className="space-y-8 text-center lg:text-left">
            <div className="relative">
              {/* Animated background elements */}
              <div className="absolute -top-20 -left-20 w-40 h-40 bg-yellow-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse"></div>
              <div className="absolute -bottom-20 -right-20 w-40 h-40 bg-orange-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse delay-1000"></div>

              {/* Main bulb illustration */}
              <div className="relative z-10 flex justify-center lg:justify-start mb-8">
                <div className="relative">
                  <div className="absolute inset-0 bg-yellow-400 rounded-full blur-3xl opacity-30 animate-pulse"></div>
                  <div className="relative bg-gradient-to-br from-yellow-300 to-orange-400 p-8 rounded-full shadow-2xl">
                    <Lightbulb className="w-24 h-24 text-white" />
                  </div>
                  <div className="absolute -top-2 -right-2">
                    <Sparkles className="w-8 h-8 text-yellow-500 animate-bounce" />
                  </div>
                </div>
              </div>

              <div className="space-y-6">
                <div className="inline-flex items-center gap-2 bg-yellow-100 text-yellow-800 px-4 py-2 rounded-full text-sm font-medium">
                  <Rocket className="w-4 h-4" />
                  TACTOS Innovation Hub
                </div>

                <h1 className="text-4xl lg:text-4xl font-bold bg-gradient-to-r from-yellow-600 to-orange-600 bg-clip-text text-transparent leading-tight">
                  Unlock Your Next Big Idea
                </h1>

                <p className="text-lg text-gray-600 max-w-2xl leading-relaxed">
                  Transform your raw concepts into startup-ready ventures through expert guidance, real-world
                  validation, and tailored resources — all in one comprehensive platform.
                </p>

                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-8">
                  <div className="text-center p-4 bg-white/50 rounded-xl backdrop-blur-sm">
                    <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-2">
                      <Users className="w-6 h-6 text-yellow-600" />
                    </div>
                    <h3 className="font-semibold text-gray-800">Expert Guidance</h3>
                    <p className="text-sm text-gray-600">Industry mentors</p>
                  </div>
                  <div className="text-center p-4 bg-white/50 rounded-xl backdrop-blur-sm">
                    <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-2">
                      <Target className="w-6 h-6 text-orange-600" />
                    </div>
                    <h3 className="font-semibold text-gray-800">Validation</h3>
                    <p className="text-sm text-gray-600">Market testing</p>
                  </div>
                  <div className="text-center p-4 bg-white/50 rounded-xl backdrop-blur-sm">
                    <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-2">
                      <Rocket className="w-6 h-6 text-yellow-600" />
                    </div>
                    <h3 className="font-semibold text-gray-800">Resources</h3>
                    <p className="text-sm text-gray-600">Tailored tools</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side Form */}
          <div className="w-full max-w-2xl mx-auto">
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-2xl border-0 overflow-hidden">
              {/* Card Header */}
              <div className="text-center px-6 py-6">
                <div className="flex items-center justify-center gap-2 mb-2">
                  <Lightbulb className="w-6 h-6 text-yellow-600" />
                  <h2 className="text-2xl font-bold bg-gradient-to-r from-yellow-600 to-orange-600 bg-clip-text text-transparent">
                    Business Ideation Hub
                  </h2>
                </div>
                <p className="text-gray-600">Bring your startup idea to life!</p>
              </div>

              {/* Card Content */}
              <div className="px-6 py-2 space-y-6">
                {errorMessage && (
                  <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg animate-in slide-in-from-top-2">
                    <p className="text-sm">{errorMessage}</p>
                  </div>
                )}

                {submitted ? (
                  <div className="text-center space-y-6 py-8">
                    <div className="relative">
                      <div className="absolute inset-0 bg-green-200 rounded-full blur-2xl opacity-30"></div>
                      <div className="relative bg-gradient-to-br from-green-400 to-emerald-500 p-6 rounded-full w-24 h-24 mx-auto flex items-center justify-center">
                        <CheckCircle className="w-12 h-12 text-white" />
                      </div>
                    </div>

                    <div className="space-y-2">
                      <h2 className="text-2xl font-bold text-green-600">🎉 Submission Successful!</h2>
                      <p className="text-gray-600">
                        Thank you for joining our Business Ideation Hub. We'll be in touch soon!
                      </p>
                    </div>

                    <button
                      onClick={() => {
                        setSubmitted(false)
                        setStep(0)
                        setFormData({
                          fullName: "",
                          email: "",
                          phoneNumber: "",
                          district: "",
                          linkedin: "",
                          employmentStatus: "",
                          cv: null,
                        })
                      }}
                      className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-yellow-500 to-orange-500 hover:from-yellow-600 hover:to-orange-600 text-white font-medium rounded-lg transition-all duration-200 transform hover:scale-105"
                    >
                      <Lightbulb className="w-4 h-4" />
                      Create Another Idea
                    </button>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} className="space-y-6">
                    {/* Section Header */}
                    <div className="text-center space-y-2">
                      <div className="flex items-center justify-center gap-2">
                        {sections[step]?.icon}
                        <h3 className="text-xl font-semibold text-gray-800">{sections[step]?.title}</h3>
                      </div>
                      <p className="text-gray-600 text-sm">{sections[step]?.subtitle}</p>
                    </div>

                    {/* Form Fields */}
                    <div className="space-y-4">
                      {sections[step]?.fields?.map((field, index) => (
                        <div key={index} className="space-y-2">
                          <label className="block text-sm font-medium text-gray-700">
                            {field.label}
                            {field.required && <span className="text-red-500 ml-1">*</span>}
                          </label>

                          {field.type === "radio" ? (
                            <div className="grid grid-cols-1 gap-2">
                              {field.options.map((option, idx) => (
                                <label
                                  key={idx}
                                  className="flex items-center space-x-3 p-3 border border-gray-200 rounded-lg hover:bg-gray-50 hover:border-yellow-300 transition-all duration-200 cursor-pointer"
                                >
                                  <input
                                    type="radio"
                                    name={field.name}
                                    value={option}
                                    checked={formData[field.name] === option}
                                    onChange={handleChange}
                                    className="w-4 h-4 text-yellow-600 border-gray-300 focus:ring-yellow-500"
                                  />
                                  <span className="text-gray-700">{option}</span>
                                </label>
                              ))}
                            </div>
                          ) : field.type === "file" ? (
                            <div className="relative">
                              <input
                                type="file"
                                name={field.name}
                                onChange={handleChange}
                                accept={field.accept}
                                className="hidden"
                                id={`file-${field.name}`}
                              />
                              <label
                                htmlFor={`file-${field.name}`}
                                className="flex items-center justify-center gap-3 p-6 border-2 border-dashed border-gray-300 rounded-lg hover:border-yellow-400 hover:bg-yellow-50 transition-all duration-200 cursor-pointer group"
                              >
                                <Upload className="w-5 h-5 text-gray-400 group-hover:text-yellow-500 transition-colors" />
                                <span className="text-gray-600 group-hover:text-gray-700">
                                  {formData[field.name] ? formData[field.name].name : "Click to upload PDF"}
                                </span>
                              </label>
                            </div>
                          ) : field.type === "select" ? (
                            <select
                              name={field.name}
                              value={formData[field.name] || ""}
                              onChange={handleChange}
                              className="w-full h-12 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 transition-all duration-200"
                            >
                              <option value="">-- Select --</option>
                              {field.options.map((option, idx) => (
                                <option key={idx} value={option}>
                                  {option}
                                </option>
                              ))}
                            </select>
                          ) : field.type === "textarea" ? (
                            <textarea
                              name={field.name}
                              value={formData[field.name] || ""}
                              onChange={handleChange}
                              placeholder={field.placeholder}
                              rows={3}
                              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 transition-all duration-200 resize-none"
                            />
                          ) : (
                            <input
                              type={field.type}
                              name={field.name}
                              value={formData[field.name] || ""}
                              onChange={handleChange}
                              placeholder={field.placeholder}
                              className="w-full h-12 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 transition-all duration-200"
                            />
                          )}
                        </div>
                      ))}
                    </div>

                    {/* Navigation Buttons */}
                    <div className="flex justify-between pt-6">
                      {step > 0 && (
                        <button
                          type="button"
                          onClick={() => setStep((prev) => prev - 1)}
                          className="inline-flex items-center gap-2 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 hover:border-gray-400 transition-all duration-200"
                        >
                          <ArrowLeft className="w-4 h-4" />
                          Back
                        </button>
                      )}

                      <div className="ml-auto">
                        {step === 0 ? (
                          <button
                            type="button"
                            onClick={handleNext}
                            className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-yellow-500 to-orange-500 hover:from-yellow-600 hover:to-orange-600 text-white font-medium rounded-lg transition-all duration-200 transform hover:scale-105"
                          >
                            Next
                            <ArrowRight className="w-4 h-4" />
                          </button>
                        ) : (
                          <button
                            type="submit"
                            disabled={loading}
                            className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-yellow-500 to-orange-500 hover:from-yellow-600 hover:to-orange-600 disabled:opacity-50 disabled:cursor-not-allowed text-white font-medium rounded-lg transition-all duration-200 transform hover:scale-105 disabled:transform-none"
                          >
                            {loading ? (
                              <>
                                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                Submitting...
                              </>
                            ) : (
                              <>
                                <Rocket className="w-4 h-4" />
                                Submit
                              </>
                            )}
                          </button>
                        )}
                      </div>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
